/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRouter } from "next/navigation";

interface CareItem {
  id: number;
  title?: string;
  description?: string;
  image: string;
  url?: string | null;
  banner_links?: Array<{
    id: number;
    linkable_type?: string | null;
    linkable_id?: number;
    banner_management_id?: number;
    type?: string;
  }>;
}

interface HomeCareProps {
  cares?: CareItem[];
}

function HomeCare({ cares = [] }: HomeCareProps) {
  const router = useRouter();
  type Slider = any;
  const sliderRef = useRef<Slider | null>(null);

  // Don't render if no cares data
  if (!cares || cares.length === 0) {
    return null;
  }

  const settings2 = {
    infinite: cares.length > 8,
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          arrows: false,
          slidesToScroll: 1,
          infinite: cares.length > 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          infinite: cares.length > 2,
        },
      },
    ],
  };

  const handleCareClick = (care: CareItem) => {
    if (care.url) {
      router.push(care.url);
    } else if (care.banner_links && care.banner_links.length > 0) {
      const firstLink = care.banner_links[0];
      if (firstLink.type === "category" && firstLink.linkable_id) {
        router.push(`/product/product-category?categoryIds=${firstLink.linkable_id}`);
      } else if (firstLink.linkable_id) {
        // Fallback: navigate with category_id even if type is not explicitly "category"
        router.push(`/product/product-category?categoryIds=${firstLink.linkable_id}`);
      } else {
        // Fallback to search with title
        const careTitle = care.title || "Care";
        router.push(`/product/product-category?type=care&search=${encodeURIComponent(careTitle)}`);
      }
    } else if (care.title) {
      // Fallback to search with title
      router.push(`/product/product-category?type=care&search=${encodeURIComponent(care.title)}`);
    }
  };

  return (
    <>
      <section className="home_care">
        <div className="container">
          <div className="s_head text_center hd_3">
            <h2 className="fw_med f_Jost">Featured Categories</h2>
          </div>
          <Slider ref={sliderRef} {...settings2} className="care_slider">
            {cares.map((care) => (
              <div
                key={care.id}
                className="care_isstem"
                onClick={() => handleCareClick(care)}
                style={{ cursor: care.url || care.banner_links?.length ? 'pointer' : 'default' }}
              >
                <figure>
                  <img src={care.image} alt={care.title || care.description || "care"} />
                  {/* {care.description && <figcaption>{care.description}</figcaption>} */}
                </figure>
                {/* <p>{care.title}</p> */}
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
}

export default HomeCare;
